export default __webpack_public_path__ + "static/media/solar_pan_grid.91277e31.jpg";